import PortailStatsController from './portail.stats.controller';

export default {
    controller: PortailStatsController,
    template: require('./portail.stats.tpl.html')
};
